module.exports = __webpack_public_path__ + "static/logo-light-tall-4d3d25a1f7c5407d77001ec404f6d4ab.png";